import React from 'react';
import { useSelector } from 'react-redux';
import {
  EDIT_ACCOUNT_INFO_ACTION,
  EDIT_GENERAL_INFO_ACTION,
  EDIT_USER,
  EDIT_USER_OFFICE_INFO,
  GET_ALL_SKILL_CATEGORIES_ACTION,
  GET_ALL_SOFTWARES_ACTION,
  PHONE_VERIFICATION_ACTION
} from '../../../actions';
import { createLoadingSelector } from '../../../api/selectors';
import CustomSpinner from '../../../commonComponents/CustomSpinner';
import { Colors } from '../../../themes/colors';

const actions = [
  EDIT_GENERAL_INFO_ACTION,
  EDIT_ACCOUNT_INFO_ACTION,
  PHONE_VERIFICATION_ACTION,
  EDIT_USER_OFFICE_INFO,
  GET_ALL_SOFTWARES_ACTION,
  GET_ALL_SKILL_CATEGORIES_ACTION,
  EDIT_USER
];

export const ContentLayout = ({ isRegistration, children }) => {
  const loadingSelector = createLoadingSelector(actions);
  const isLoading = useSelector((state) => loadingSelector(state));

  return (
    <div
      style={{
        backgroundColor: Colors.white,
        width: 720,
        paddingTop: 60,
        paddingRight: 111,
        paddingLeft: 111,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxShadow: '0px 3px 10px 1px rgba(0, 0, 0, 0.15)',
        marginBottom: 33,
        ...(isRegistration && { padding: 0, width: 1200 })
      }}
    >
      {isLoading ? <CustomSpinner isLoading /> : children}
    </div>
  );
};
